import { useLang } from '@/i18n';
import { getMemberListProducts } from '@/service/vip';
import { useGlobal } from '@/utils/useGlobal';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

const UsageScenarios: React.FC = () => {
    const { t } = useLang('dp3.landing.UsageScenarios');
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const variantId = '44261300175009';
    const contentList: any = {
        variantId,
        title: t('title'),
        desc: [t('desc1'), t('desc2'), t('desc3'), t('desc4'), t('desc5')],
        prodImg: '',
    };

    const handlePushGtm = (product: string, url: string) => {
        saveCookieForShopify(url, locale);
    };

    const [productList, setProductList] = useState<any>(contentList);

    const getProductData = () => {
        const arr = JSON.parse(JSON.stringify(productList));
        try {
            getMemberListProducts(
                {
                    variantIds: [variantId],
                },
                locale,
            ).then((res) => {
                if (res?.code === '0' && res.data) {
                    // arr.title = res.data[0].skuTitle; // 前端 json 配置 title
                    arr.price = res.data[0].price;
                    arr.compareAtPrice = res.data[0].compareAtPrice;
                    arr.prodImg = res.data[0].variantImg;
                    console.log('arr3', arr);
                    setProductList(arr);
                }
            });
        } catch (error) {
            console.log('error->>', error);
        }
    };

    useEffect(() => {
        getProductData();
    }, []);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secne = AniContainer.create({
                triggerElement: '#Section2JP',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secne.destroy();
            };
        }
    }, []);
    return (
        <section className={`${styles.UsageScenarios} GtmModuleData-section`} id="UsageScenarios" data-section-id="UsageScenarios">
            <div className="scenarios-bg">
                <div className="product-item">
                    <div className="left-prod">{load && <EcoImg pc={productList.prodImg} alt={productList.title}></EcoImg>}</div>
                    <div className="right-content">
                        <div className="right-top">
                            <div className="right-title">{productList.title}</div>
                            <ul className="desc-container">
                                {productList.desc.map((item: any, index: number) => (
                                    <li key={index} className="item-desc">
                                        <span className="dot" />
                                        <div className="right-desc">{item}</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="price-row">
                            {productList.price && (
                                <div>
                                    <span className="price">{FormatMoneyLocal(productList.price, locale)}</span>
                                    <span className="price-suffix">（税込）</span>
                                </div>
                            )}
                            {productList.compareAtPrice && productList.compareAtPrice !== productList.price && (
                                <span className="compare">{FormatMoneyLocal(productList.compareAtPrice, locale)}（税込）</span>
                            )}
                        </div>
                        <div className="btn-container">
                            <EcoLink
                                className={`buy-btn left-btn GtmModuleData-btn-href __btn_dp3_1`}
                                href={`https://jp.ecoflow.com/products/delta-pro-3`}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: productList.title,
                                    position: t('title'),
                                    __btn_id1: `__btn_dp3_1`,
                                    __btn_type: 'href',
                                    __btn_id2: `https://jp.ecoflow.com/products/delta-pro-3`,
                                }}
                                onClick={() =>
                                    handlePushGtm(productList.title, `https://${locale}.ecoflow.com/products/delta-3-1000-air-portable-power-station`)
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t('left_btn')}
                            </EcoLink>
                            <EcoLink
                                className={`buy-btn right-btn GtmModuleData-btn-href __btn_dp3_2`}
                                href={`https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'checkout',
                                    button_name: t('right_btn'),
                                    product_name: productList.title,
                                    position: t('title'),
                                    __btn_id1: `__btn_dp3_2`,
                                    __btn_type: 'href',
                                    __btn_id2: `hhttps://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`,
                                }}
                                onClick={() =>
                                    handlePushGtm(productList.title, `https://${locale}.ecoflow.com/products/delta-3-1000-air-portable-power-station`)
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t('right_btn')}
                            </EcoLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UsageScenarios;
